import vCard from "./v-card.vue";

export default Vue => {
  Vue.component("v-card", vCard);
};
